import { useState, useEffect } from "react";
import axios from "axios";
import { X, Info, AlertTriangle, Wrench } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ICONS = { info: Info, warning: AlertTriangle, maintenance: Wrench };
const STYLES = {
  info: "bg-blue-500/10 border-blue-500/20 text-blue-300",
  warning: "bg-amber-500/10 border-amber-500/20 text-amber-300",
  maintenance: "bg-violet-500/10 border-violet-500/20 text-violet-300",
};

export default function AnnouncementBanner() {
  const [announcements, setAnnouncements] = useState([]);
  const [dismissed, setDismissed] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/announcements/active`);
        setAnnouncements(res.data || []);
      } catch {}
    };
    fetch();
  }, []);

  const visible = announcements.filter(a => !dismissed.includes(a.id));
  if (visible.length === 0) return null;

  return (
    <div className="space-y-2 mb-4" data-testid="announcement-banner">
      {visible.map(a => {
        const Icon = ICONS[a.type] || Info;
        const style = STYLES[a.type] || STYLES.info;
        return (
          <div key={a.id} className={`flex items-center gap-3 px-4 py-2.5 rounded-xl border ${style}`}>
            <Icon className="h-4 w-4 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <span className="text-sm font-medium">{a.title}</span>
              <span className="text-sm ml-2 opacity-80">{a.message}</span>
            </div>
            <button onClick={() => setDismissed(prev => [...prev, a.id])} className="opacity-50 hover:opacity-100 transition">
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
